export const BCT_TRACKING_ADD_TO_EVENT = 'tracking.bct.addToEvent';
export const BCT_TRACKING_SUBMIT_EVENT = 'tracking.bct.submitEvent';
export const BCT_TRACKING_SUBMIT_ACTION = 'tracking.bct.submitAction';
export const BCT_TRACKING_SUBMIT_MOVE = 'tracking.bct.submitMove';
export const BCT_TRACKING_SUBMIT_MOVE_ACTION = 'tracking.bct.submitMoveAction';
export const BCT_TRACKING_ADD_TO_PI = 'tracking.bct.addToPageImpression';
export const BCT_TRACKING_ADD_FEATURES_TO_PI = 'tracking.bct.addFeaturesToPageImpression';
export const BCT_ADD_ACTION_TO_EVENT_TRACKING = 'tracking.bct.addActionToEvent';
export const BCT_TRACK_ON_NEXT_PAGE_IMPRESSION = 'tracking.bct.trackOnNextPageImpression';
export const BCT_TRACKING_SUBMIT_MINI_ACTIONS = 'tracking.bct.submitMiniActions';
